module.exports = __webpack_public_path__ + "img/banner3.af15e4e9.png";